import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const REQUESTS_V2_ANALYTICS_ACTIONS = {
  OPENED_REQUEST_V2_SUBMISSION_PAGE: {
    module: ANALYTICS_MODULE.REQUESTS_V2,
    action: 'opened_request_v2_submission_page',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_REQUEST_V2_DEFINITION_PAGE: {
    module: ANALYTICS_MODULE.REQUESTS_V2,
    action: 'opened_request_v2_definition_page',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_REQUEST_V2_PROGRESS_AND_OUTPUTS_TAB: {
    module: ANALYTICS_MODULE.REQUESTS_V2,
    action: 'clicked_request_v2_progress_and_outputs_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_REQUEST_V2_REQUEST_TAB: {
    module: ANALYTICS_MODULE.REQUESTS_V2,
    action: 'clicked_request_v2_request_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_REQUESTS_V2_DASHBOARD: {
    module: ANALYTICS_MODULE.REQUESTS_V2,
    action: 'opened_requests_v2_dashboard',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_REQUESTS_V2_REQUEST_TYPES_TAB: {
    module: ANALYTICS_MODULE.REQUESTS_V2,
    action: 'clicked_requests_v2_request_types_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_REQUESTS_V2_DASHBOARD_TAB: {
    module: ANALYTICS_MODULE.REQUESTS_V2,
    action: 'clicked_requests_v2_dashboard_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_REQUESTS_V2_CREATE_SHORTCUT: {
    module: ANALYTICS_MODULE.REQUESTS_V2,
    action: 'clicked_requests_v2_create_shortcut',
    actionCategory: ACTION_CATEGORY.READ,
  },
};

// Modal Types
export const CREATE_REQUEST_V2_MODAL_TYPE = 'create_request_v2_modal';
